<style scoped>

.fill-height {
  height: 80vh;
}

.flex-center {
  -webkit-box-align: center;
  -webkit-align-items: center;
    -ms-flex-align: center;
      align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
    -ms-flex-pack: center;
      justify-content: center;
}

.position-ref {
  position: relative;
}

.content {
  max-width: 600px;
}
</style>

<template>
  <div class="component-wrapper">
    <div class="app-content">
      <div class="flex-center display-flex position-ref fill-height">
        <div class="content text-align-center">
          <h1>
            The page {{$route.params.url}} does not exist.
          </h1>
          <small>
            Please carefully check the requested url.
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>
